var React = require('react');

function LeftCircleArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.43 1.614l-6 6 6 6M2.43 7.614h12","fill":"none","stroke":"#2D294F","strokeWidth":"1.5"}));
}

LeftCircleArrow.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = LeftCircleArrow;

LeftCircleArrow.default = LeftCircleArrow;
